import { render, staticRenderFns } from "./FlatFiber.vue?vue&type=template&id=98f49e64&"
import script from "./FlatFiber.vue?vue&type=script&lang=js&"
export * from "./FlatFiber.vue?vue&type=script&lang=js&"
import style0 from "./FlatFiber.vue?vue&type=style&index=0&id=98f49e64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports